var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-alert',{attrs:{"show":""}},[_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_c('h4',[_vm._v("¡Acceso no autorizado!. Este enlace de examen está asignado a otra cuenta de correo electrónico.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }